module.exports = __webpack_public_path__ + "static/media/teachers-icon.64185c36.svg";